<template>
  <div v-if="modalConfirm.show" class="modal-backdrop">
    <div
      class="modal fade"
      :class="{ show: modalConfirm.show }"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="height: 25vh">
          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ modalConfirm.title }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="close()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body" style="height: calc(25vh - 120px)">
            <div
              class="d-flex align-items-center justify-content-center w-100 h-100"
            >
              <h4>{{ modalConfirm.message }}</h4>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer" style="height: 70px">
            <div class="d-flex align-items-center justify-content-end w-100">
              <div class="d-flex justify-content-end w-100">
                <div class="d-inline pe-2">
                  <button type="button" class="btn btn-danger" @click="close()">
                    {{ $t("modal.cancel") }}
                  </button>
                </div>
                <div class="d-inline">
                  <button type="button" class="btn btn-primary" @click="onOk()">
                    {{ $t("modal.ok") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModalMixin } from "@/mixins/ModalMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [ModalMixin],
  computed: {
    ...mapGetters("modals", ["modalConfirm"]),
  },
  methods: {
    close() {
      this.hideConfirm();
    },
    onOk() {
      if (this.modalConfirm.callback) {
        this.modalConfirm.callback(true);
      }
      this.close();
    },
  },
};
</script>
